
const config = {
    trackerUrl: "https://trackerapihml.newsgps.com.br/tracker"
};
// const config = {
//     trackerUrl: "https://localhost:44399/tracker"
// };
export default config;